import { render, staticRenderFns } from "./ChangeKey.vue?vue&type=template&id=5cb753c8&"
import script from "./ChangeKey.vue?vue&type=script&lang=js&"
export * from "./ChangeKey.vue?vue&type=script&lang=js&"
import style0 from "./ChangeKey.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports